module.exports = __webpack_public_path__ + "assets/img/about_culture1.39191803.png";